import { CURRENT_GAME_VERSION } from "../constants";

export const checkIfTextIsURL = (text: string) => {
  return text.startsWith("http") || text.startsWith("https");
};

export const isLegacyGame = (game: {
  id: string;
  code: string;
  version?: number;
}) => {
  // the version was undefined for legacy games
  return game.version === undefined;
};

export const generateGamePayload = (game: {
  id?: string;
  type: string;
  code: string;
  title: string;
  questionData?: any;
}) => {
  const payload: {
    id: string;
    code: string;
    title: string;
    version: number;
    timestamp: number;
    type: string;
    questionData?: any;
  } = {
    id: game.id ?? crypto.randomUUID(),
    code: game.code,
    title: game.title,
    version: CURRENT_GAME_VERSION,
    timestamp: Date.now(),
    type: game.type,
  };

  if (game.questionData) {
    payload.questionData = game.questionData;
  }

  return payload;
};
